import { FileText, Loader2, Trash2 } from 'lucide-react';

// Liste des documents d'une compilation multi-docs + barre de capacité tokens.
export default function MultiDocList({ docs, totalTokens, maxTokens, onRemove }) {
    if (docs.length === 0) return null;
    const ratio = Math.min(1, totalTokens / maxTokens);
    const color = ratio >= 1 ? '#ef4444' : ratio >= 0.8 ? '#f59e0b' : '#8B5CF6';
    return (
        <>
            <div className="mt-multi-doc-list" style={{ marginTop: 10, border: '1px solid var(--card-border)', borderRadius: 8, overflow: 'hidden' }}>
                {docs.map((doc, idx) => (
                    <div key={idx} style={{
                        display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px',
                        borderBottom: idx < docs.length - 1 ? '1px solid var(--card-border)' : 'none',
                        background: doc.error ? 'rgba(239,68,68,0.08)' : 'var(--surface)',
                    }}>
                        <FileText size={16} style={{ flexShrink: 0, color: 'var(--primary, #8B5CF6)' }} />
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontWeight: 500, fontSize: '0.88em', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {doc.name}
                            </div>
                            <div style={{ fontSize: '0.76em', color: 'var(--text-muted)' }}>
                                {(doc.size / 1024).toFixed(0)} Ko
                                {doc.extracting && <> · <Loader2 size={10} className="spin" /> extraction…</>}
                                {!doc.extracting && !doc.error && (
                                    <> · {doc.text.length.toLocaleString()} chars · ~{doc.tokens.toLocaleString()} tokens</>
                                )}
                                {doc.error && <> · <span style={{ color: 'var(--danger)' }}>{doc.error}</span></>}
                            </div>
                        </div>
                        <button type="button" onClick={() => onRemove(idx)} title="Retirer"
                            style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-muted)', padding: 4 }}>
                            <Trash2 size={14} />
                        </button>
                    </div>
                ))}
            </div>

            {/* Barre de capacité tokens */}
            <div style={{ marginTop: 10 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.78em', marginBottom: 4 }}>
                    <span style={{ color: 'var(--text-muted)' }}>Capacité IA</span>
                    <span style={{ color, fontWeight: 600 }}>
                        {totalTokens.toLocaleString()} / {maxTokens.toLocaleString()} tokens
                    </span>
                </div>
                <div style={{ height: 6, background: 'var(--card-border)', borderRadius: 3, overflow: 'hidden' }}>
                    <div style={{ width: `${ratio * 100}%`, height: '100%', background: color, transition: 'width 0.3s, background 0.3s' }} />
                </div>
            </div>
        </>
    );
}
